module.exports = __webpack_public_path__ + "assets/img/6_582_big.99db9d07.jpg";